import { render } from "./renewContractDialog.vue?vue&type=template&id=b8b454ea&scoped=true"
import script from "./renewContractDialog.vue?vue&type=script&lang=js"
export * from "./renewContractDialog.vue?vue&type=script&lang=js"

import "./renewContractDialog.vue?vue&type=style&index=0&id=b8b454ea&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b454ea"]])

export default __exports__